import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-query';

import { fetchProductModel } from 'projects/utils';

export const ProductModelContext = React.createContext({
  status: 'loading',
  products: null,
});

export const useProductModelContext = () => React.useContext(ProductModelContext);

export const ProductModelProvider = ({ children }) => {
  const { data, status } = useQuery('productModel', fetchProductModel);
  const productModel = {
    status,
    products: data,
  };
  return (
    <ProductModelContext.Provider value={productModel}>
      {children}
    </ProductModelContext.Provider>
  );
};
